export enum ButtonTypes {
  SIMPLE = 'simple',
}
